import { Theme } from '@mui/material';
import Highcharts from 'highcharts/highstock';

import { CHART_GRID_COLOR } from '@/components/Chart/hooks/options/useChartFunctions';

const getFullscreenTooltip = (
  createTooltipFormatter: (
    allChartSeries: Highcharts.Series[],
    hoveredPointXValue: string | number | undefined
  ) => string,
  theme: Theme
) => {
  const tooltip: Highcharts.TooltipOptions = {
    positioner() {
      return { x: 100, y: 80 };
    },
    formatter(): string {
      const allChartSeries: Highcharts.Series[] = this.series.chart.series;
      const hoveredPointXValue = this.x;
      return createTooltipFormatter(allChartSeries, hoveredPointXValue);
    },
    className: 'tooltip-fullscreen-chart',
    enabled: true,
    split: false,
    followPointer: true,
    backgroundColor: CHART_GRID_COLOR,
    borderRadius: 0,
    useHTML: true,
    shape: 'rect',
    style: {
      zIndex: 1303,
      color: theme.palette.text.primary,
      fontFamily: 'Cairo, sans-serif'
    }
  };
  return { tooltip };
};

export default getFullscreenTooltip;
